module.exports = __webpack_public_path__ + "img/1F62F.a6d58be0.svg";